import { InsightsResponseSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type TimelineInsightsResponseInput = z.input<typeof InsightsResponseSchema>;
export type TimelineInsightsResponseOutput = z.output<typeof InsightsResponseSchema>;

export function serializeTimelineInsightsResponse(
  payload: TimelineInsightsResponseInput
): TimelineInsightsResponseOutput {
  return InsightsResponseSchema.parse(payload);
}
